<template>
  <Accordion title="Dados do Depósito">
    <div class="grid grid-cols-4 gap-3">
      <Select v-if="!routeInfo.params.id" :items="type" v-model="localValue.type" label="Tipo" required :error="localErrors.type" />
      <InputText v-model="localValue.name" label="Nome do Depósito" :error="localErrors.name" required placeholder="Insira o Nome do Depósito" />
      <TextArea
        v-if="!routeInfo.params.id"
        class="col-span-4"
        v-model="localValue.description"
        label="Descrição"
        placeholder="Descrição do Depósito"
        :error="localErrors.description" />
    </div>
  </Accordion>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'
import { get } from '@/crud'
import { useRoute, useRouter } from 'vue-router'

const router = useRoute()
const routeInfo = useRoute()

const type = [
  { label: 'Físico', value: 'physic' },
  { label: 'Equipe', value: 'team' },
  { label: 'Veículo', value: 'vehicles' },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  }
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  }
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
